export default __webpack_public_path__ + "static/media/foto1.e3c58ea0.jpg";